import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import {
  BrandingService,
  AuthenticationService,
} from '@tamilarasitech/tt-branding-app-lib';
import { MessageService } from '@tamilarasitech/tt-branding-app-lib';
import { CommonModule } from '@angular/common';
import { TtUIComponentsModule } from '@tamilarasitech/tt-branding-app-lib';
import { FieldConfig } from '@tamilarasitech/tt-branding-app-lib';

export interface StepType {
  label: string;
  fields: FieldConfig[];
}

@Component({
  selector: 'tt-unregistered',
  templateUrl: './unregistered.component.html',
  styleUrls: ['./unregistered.component.scss'],
  standalone: true,
  imports: [CommonModule, TtUIComponentsModule],
})
export class UnregisteredComponent implements OnInit {
  model: any = {};
  user: any;

  _formId: BehaviorSubject<string> = new BehaviorSubject('registration');
  formId$ = this._formId.asObservable();

  _model: BehaviorSubject<any> = new BehaviorSubject({});
  model$ = this._model.asObservable();

  config: any;
  disableWillDoLater: boolean = false;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private branding: BrandingService,
    private messageService: MessageService
  ) {}

  cancel(model: any) {
    this.router.navigateByUrl('/dashboard');
  }
  async submit(model: any) {
    try {
      if (this.user?.mobile) {
        this.model['mobile'] = this.user.mobile;
      }
      if (this.model?.handler) {
        this.model['id'] = this.model.handler;
      }
      const formData = { ...this.model, ...model };
      const result = await this.authService.registerBusinessAccount(formData);
      if (result) {
        this.messageService.sendMessage({
          status: 'success',
          text: 'The Admin App for your Business has been setup successfully!',
        });
        this.router.navigateByUrl('/dashboard');
      } else {
        this.messageService.sendMessage({
          status: 'error',
          text: 'Business Admin App setup Failed!',
        });
        this.router.navigateByUrl('/error');
      }
    } catch (error) {
      this.messageService.sendMessage({
        status: 'error',
        text: 'An unexpected error occurred. Please try again later.',
      });
    }
  }

  ngOnInit(): void {
    this.branding.config$.subscribe((config: any) => (this.config = config));
    this.authService.currentuser$.subscribe((data: any) => {
      this.user = data;
      if (Boolean(data.authorized)) this.router.navigateByUrl('/dashboard');
      else if (data?.uid) {
        this.user = data;
        this.model['id'] = data.id;
        this.model['uid'] = data.uid;
        this.model['mobile'] = data.mobile || '';
        this._model.next(this.model);
      } else this.router.navigateByUrl('/auth/login');
    });
  }
}

